export default {
  title: '航线管理',
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '中文名、英文名',
    routeType: '航线类型',
    routeTypePlaceholder: '选择航线类型',
    routeLevel: '航线层级',
    routeLevelPlaceholder: '选择航线层级',
    status: '状态',
    statusPlaceholder: '选择状态',
    searchButton: '搜索',
    resetButton: '重置'
  },
  actions: {
    syncRelation: '\u540c\u6b65\u6e2f\u53e3\u5173\u8054',
    add: '自主新增',
    reference: '引用基础数据',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    recordsCount: '共 {count} 条记录'
  },
  table: {
    routeNameShort: '\u822a\u7ebf\u7b80\u79f0',
    routeLevel: '层级',
    parent: '上级航线',
    routeNameCn: '航线名称（中文）',
    routeNameEn: '航线名称（英文）',
    routeType: '航线类型',
    status: '状态',
    dataSource: '数据来源',
    dateModified: '更新时间',
    operation: '操作'
  },
  form: {
    routeNameShort: '\u822a\u7ebf\u7b80\u79f0',
    routeNameShortPlaceholder: '\u8bf7\u8f93\u5165\u822a\u7ebf\u7b80\u79f0',
    routeType: '航线类型',
    routeLevel: '航线层级',
    parent: '上级航线',
    routeNameCn: '航线名称（中文）',
    routeNameEn: '航线名称（英文）',
    status: '状态',
    routeTypePlaceholder: '请选择航线类型',
    routeLevelPlaceholder: '请选择航线层级',
    parentPlaceholder: '请选择上级航线',
    routeNameCnPlaceholder: '请输入中文航线名称',
    routeNameEnPlaceholder: '请输入英文航线名称'
  },
  modal: {
    syncRelationTitle: '\u540c\u6b65\u5e73\u53f0\u6e2f\u53e3\u5173\u8054',
    syncRelationNotice: '\u4ec5\u5c55\u793a\u5f53\u524d\u79df\u6237\u5df2\u5f15\u7528\u7684\u5e73\u53f0\u822a\u7ebf',
    addTitle: '自主新增航线',
    editTitle: '编辑航线',
    referenceTitle: '引用基础数据',
    confirmReference: '确认引用',
    selectedTitle: '已选航线',
    selectedCount: '已选择 {count} 条',
    selected: '已选择 {count} 条航线',
    querySelected: '已选择当前筛选下 {total} 条可引用航线，已排除 {excluded} 条',
    clearSelected: '清空选择',
    platformTitle: '平台航线库',
    platformCount: '当前页可引用 {available} 条 / 共 {total} 条',
    selectAllFiltered: '选择全部筛选结果（{total}）',
    taskNotice: '已选 {count} 条，提交后将转入任务中心处理',
    excludedPreview: '已排除航线',
    remove: '移除',
    restore: '恢复',
    copyStatus: '引用状态',
    copyStatusPlaceholder: '选择引用状态',
    available: '可引用',
    exists: '已引用',
    allStatus: '全部'
  },
  routeType: {
    sea: '海运航线',
    air: '空运航线',
    unknown: '未知类型'
  },
  routeLevel: {
    first: '一级',
    second: '二级',
    third: '三级'
  },
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },
  dataSource: {
    1: '平台标准',
    2: '平台导入',
    3: '租户自建',
    4: '引用平台',
    unknown: '未知来源'
  },
  validation: {
    routeNameShortRequired: '\u8bf7\u8f93\u5165\u822a\u7ebf\u7b80\u79f0',
    routeNameShortLength: '\u822a\u7ebf\u7b80\u79f0\u4e0d\u80fd\u8d85\u8fc764\u4e2a\u5b57\u7b26',
    routeTypeRequired: '请选择航线类型',
    routeLevelRequired: '请选择航线层级',
    parentRequired: '请选择上级航线',
    routeNameCnRequired: '请输入中文航线名称',
    routeNameEnRequired: '请输入英文航线名称',
    routeNameLength: '航线名称不能超过128个字符'
  },
  confirm: {
    relationSyncTaskRedirectTitle: '\u822a\u7ebf\u6e2f\u53e3\u5173\u8054\u540c\u6b65\u4efb\u52a1\u5df2\u63d0\u4ea4',
    relationSyncTaskRedirectContent: '\u5927\u6279\u91cf\u822a\u7ebf\u6e2f\u53e3\u5173\u8054\u540c\u6b65\u5df2\u8f6c\u5165\u4efb\u52a1\u4e2d\u5fc3\u5904\u7406\uff0c\u662f\u5426\u524d\u5f80\u67e5\u770b\u8fdb\u5ea6\uff1f',
    relationSyncTaskRedirectOk: '\u524d\u5f80\u4efb\u52a1\u4e2d\u5fc3',
    relationSyncTaskRedirectCancel: '\u7559\u5728\u5f53\u524d\u9875',
    toggleStatus: '确定要{action}此航线吗？',
    batchToggleStatus: '确定要{action}选中的 {count} 条航线吗？',
    copyTaskRedirectTitle: '航线复制任务已提交',
    copyTaskRedirectContent: '大批量航线复制已转入任务中心处理，是否前往查看进度？',
    copyTaskRedirectOk: '前往任务中心',
    copyTaskRedirectCancel: '留在当前页'
  },
  messages: {
    syncRelationLoadError: '\u52a0\u8f7d\u822a\u7ebf\u5173\u8054\u540c\u6b65\u6570\u636e\u5931\u8d25',
    selectRelationSyncWarning: '\u8bf7\u9009\u62e9\u8981\u540c\u6b65\u6e2f\u53e3\u5173\u8054\u7684\u822a\u7ebf',
    syncRelationSuccess: '\u540c\u6b65\u5b8c\u6210\uff0c\u53d8\u66f4 {count} \u6761\u5173\u8054',
    syncRelationError: '\u540c\u6b65\u6e2f\u53e3\u5173\u8054\u5931\u8d25',
    syncRelationTaskSubmitted: '\u540c\u6b65\u4efb\u52a1\u5df2\u63d0\u4ea4\uff0c\u4efb\u52a1 ID\uff1a{taskId}',
    loadError: '加载航线数据失败',
    parentLoadError: '加载上级航线失败',
    platformLoadError: '加载平台航线失败',
    saveSuccess: '保存成功',
    saveError: '保存失败',
    duplicateRouteName: '同级下已存在相同中英文名称的航线，请调整后再保存',
    statusSuccess: '状态更新成功',
    statusError: '状态更新失败',
    selectWarning: '请选择要{action}的航线',
    selectReferenceWarning: '请选择要引用的航线',
    referenceSuccess: '引用完成，新增 {count} 条，跳过 {skipped} 条',
    referenceTaskSubmitted: '已提交航线复制任务，任务ID：{taskId}，预计复制 {count} 条',
    referenceTaskAlreadyRunning: '已有航线复制任务正在执行，任务ID：{taskId}',
    referenceError: '引用失败',
    readonlyWarning: '引用基础数据不允许编辑',
    statusReadonlyWarning: '当前航线不允许启用或禁用'
  }
}
